var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-hover"},[_c('div',{staticClass:"relative z-1"},_vm._l((_vm.items),function(item){return _c('div',{key:item.key,staticClass:"bg-hover__item",class:{ 'is-active' : _vm.activeItem === item.key },style:({ backgroundImage: `url(${item.image})`})})}),0),_vm._v(" "),_c('div',{staticClass:"relative z-2"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }